import { useRef } from 'react';
import { Form, Formik } from 'formik';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getMedia, getMediaArray, orderData, scrollToError } from '../../../../utils/HelperFunctions';
import { IModelGalleryItem } from '../../types/interfaces';
import SectionHeader from '../../../../components/SectionHeader';
import Button from '../../../../components/buttons/Button';
import FormGalleryUpload from '../../../../components/formInputs/FormGalleryUpload';
import useFormsIntegrationHelpers from '../../../../hooks/useFormsIntegrationHelpers';
import * as Yup from 'yup';

export default function VehicleModelsEditGallery({ images }: { images: IModelGalleryItem[] }) {
  const { id: makeId, modelId: id } = useParams();
  const formRef = useRef(null);
  const { t } = useTranslation();

  const { apiData, handleSubmit, submitLoading } = useFormsIntegrationHelpers({
    queryKey: ['models', id],
    id,
    singleGetApi: `/admin/makes/${makeId}/models/${id}`,
    editApi: `/admin/models/${id}`,
    itemName: t('model')
  });

  const initialValues = {
    ...apiData,
    body_types: null,
    vehicle_make: null,
    media: null,
    interior_colors: null,
    exterior_colors: null,
    vehicle_make_id: apiData?.vehicle_make?.id,
    body_type_ids: apiData?.body_types?.map((item: any) => item.id),
    image: getMedia(apiData?.media, 'image')?.url,
    meta_image: getMedia(apiData?.media, 'meta_image')?.url,
    brochure_en: getMedia(apiData?.media, 'brochure_en')?.url,
    brochure_ar: getMedia(apiData?.media, 'brochure_ar')?.url,
    gallery_images: orderData(getMediaArray(apiData?.media, 'gallery_images'))?.map((ele: any) => ele.url)
  };

  const validationSchema = Yup.object({
    gallery_images: Yup.array().required(t('required'))?.min(1, t('at_least_one_image'))
  });

  return (
    <div className={'model_gallery form_section'} ref={formRef}>
      <Formik
        validateOnMount
        enableReinitialize
        initialValues={initialValues}
        onSubmit={(values) => {
          let value = { ...values, _method: 'POST' };
          value.gallery_images = values.gallery_images?.map((item: any, index: number) => ({
            file: item,
            order: index + 1
          }));
          if (id) {
            value = { ...value, _method: 'PUT' };
          }
          handleSubmit({ ...value });
        }}
        validationSchema={validationSchema}
      >
        {(formik) => (
          <Form>
            <SectionHeader title={t('gallery')} customStyle="last">
              <div className="inputs_group">
                <FormGalleryUpload errors={formik?.errors?.gallery_images as string} touched={formik?.touched?.gallery_images as boolean} formik={formik} name={`gallery_images`} />
              </div>
            </SectionHeader>
            {/* <SectionHeader title={t('images')}>
              <div className='model_gallery_table_cont'>
                <p>{t("image_tap_to_re-order")}</p>
                <VehicleModelsEditGalleryTable data={formik?.values?.images} noDataMessage={t("no_images")}/>
              </div>
            </SectionHeader>
            <SectionHeader title={t('add_image')} customStyle="last">
              <VehicleModelsEditGalleryForm />
            </SectionHeader> */}
            <div className="form_button reverse">
              <Button
                loading={submitLoading}
                onClick={() => {
                  scrollToError(!formik.isValid, formRef);
                }}
              >
                <span className="bold">{t('save')}</span>
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
}
